

import React from 'react';

function ScoreIcon({ score, getIconForScore }) {


    return (
        <>
            {React.createElement(getIconForScore(score))}
        </>
    )
}

export default ScoreIcon;